// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.

// EVERY LISTING OF TASKS ASKS FOR BOTH MODALITIES.
//
// Without `modality`, `GET /admin/tasks` returns ONLY planned tasks — Core kept
// it that way so a client that could not draw a task without a tier would not
// break when one-off tasks were switched on. This panel draws them (see
// utils/modality.js), so it asks for `all`. A listing that forgot it would show
// every planned task and silently none of the one-off ones, which is exactly
// how they went missing from the board.
//
// Listings filtered by `tier_id` do not need it — a one-off task has no tier —
// and carry it anyway where they share code with the others.
export const ALL_MODALITIES = 'all';

export const taskPaths = {
    list:   ()   => 'admin/tasks',
    detail: (id) => `admin/tasks/${id}`,
    unblock: (id) => `admin/tasks/${id}/unblock`,
    // Which tasks this one waits for. Its own screen when the graph gets one.
    dependencies: (id) => `admin/tasks/${id}/dependencies`,
};

// T03 gave directing work its own routes, and the panel uses them as routes
// rather than as fields inside the content PATCH.
//
// THE WEIGHT HAS ITS OWN DOOR ON PURPOSE. `priority` is still accepted by
// `PATCH /admin/tasks/{id}`, so putting it there would have worked — and would
// have buried a priority decision inside a content edit where nobody can find
// it afterwards, and would have carried an authorized task's frozen
// specification along with it.
// One-off tasks have their own door for reading their specification and for
// authorizing it: the tier's breakdown route does not know them, and
// `PATCH /admin/tasks/{id}/promote` authorizes planned work only.
export const oneOffPaths = {
    detail:        (id) => `admin/one-off-tasks/${id}`,
    authorization: (id) => `admin/one-off-tasks/${id}/authorization`,
};

export const assignmentPaths = {
    assignment: (id) => `admin/tasks/${id}/assignment`,
    weight:     (id) => `admin/tasks/${id}/weight`,
};

// The way back: from a commit to the plan the work came out of.
// Session, `tasks:read`. Hex, 7 to 40 characters.
export const commitPaths = {
    trace: (hash) => `admin/commits/${hash}`,
};
